const { isStringValid } = require("simpul");

function makeUserLabel(props = {}) {
  let { username, display_name, withAt = true, parenthesize } = props;

  const hasUsername = isStringValid(username);

  const hasDisplayName = isStringValid(display_name);

  const hasBothNames = hasUsername && hasDisplayName;

  if (hasUsername && username.startsWith("@")) username = username.substring(1);

  if (hasBothNames && (parenthesize === true || parenthesize === "username")) {
    return `${display_name} (@${username})`;
  } else if (hasBothNames && parenthesize === "display_name") {
    return `@${username} (${display_name})`;
  } else if (hasBothNames) {
    return `${display_name} @${username}`;
  } else if (hasDisplayName) {
    return display_name;
  } else if (hasUsername) {
    return withAt ? "@" + username : username;
  } else return "";
}

module.exports = makeUserLabel;
